import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { appHref } from '@/config/config'
import { QuotesEvent, useTrackQuotesEvent } from './quotesAnalytics'

/** Shown once a cart is sent to the broker — applying stamps the indication, it is not a bind. */
export function CheckoutConfirmationDialog({
  open,
  onOpenChange,
}: {
  open: boolean
  onOpenChange: (open: boolean) => void
}) {
  const track = useTrackQuotesEvent()

  function dismiss(action: 'dashboard' | 'close') {
    track(QuotesEvent.CHECKOUT_CONFIRMATION_DISMISSED, { action })
  }

  return (
    <Dialog
      open={open}
      onOpenChange={(next) => {
        if (!next) dismiss('close')
        onOpenChange(next)
      }}
    >
      <DialogContent size="sm">
        <DialogHeader>
          <DialogTitle>You&rsquo;re all set</DialogTitle>
          <DialogDescription asChild>
            <div className="flex flex-col gap-3">
              <p>Your broker will be in touch with next steps within the next 24 hours.</p>
              <p>
                You&rsquo;ll have a chance to review everything before sharing payment information and
                activating your coverage.
              </p>
            </div>
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button
            className="w-full"
            size="lg"
            href={appHref('/insure/insurance')}
            onClick={() => dismiss('dashboard')}
          >
            Go to insurance
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
